import http from "@/plugins/axios";


export default {
    queryExchangeAccountEnum(){
        return http.get({
            url: '/admin/hedge/query/exchange/account/enum',
        })
    },

    queryExchangeChainEnum(){
        return http.get({
            url: '/admin/query/exchange/chain/enum',
        })
    },

    pageQueryChainBalanceSnapshot(data){
        return http.post({
            url: '/admin/page/query/chain/balance/snapshot',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryChainBalanceSnapshot(data){
        return http.post({
            url: '/admin/query/chain/balance/snapshot',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    pageQueryChainTransaction(data){
        return http.post({
            url: '/admin/page/query/chain/transaction',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryChainTransaction(data){
        return http.post({
            url: '/admin/query/chain/transaction',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryHedgeBalanceBook(data){
        return http.post({
            url: '/admin/hedge/balance/book',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryHedgeBalanceBookAll(data){
        return http.post({
            url: '/admin/hedge/balance/book/all',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    pageQueryHedgeHistoryDepositWithdraw(data){
        return http.post({
            url: '/admin/hedge/history/deposit/withdraw',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    allQueryHedgeHistoryDepositWithdraw(data){
        return http.post({
            url: '/admin/hedge/history/deposit/withdraw/all',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    pageQueryHedgeHistoryOrders(data){
        return http.post({
            url: '/admin/hedge/history/trades',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    allQueryHedgeHistoryOrders(data){
        return http.post({
            url: '/admin/hedge/history/trades/all',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    pageQueryHedgeHistoryTransfer(data){
        return http.post({
            url: '/admin/hedge/history/transfer',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    allQueryHedgeHistoryTransfer(data){
        return http.post({
            url: '/admin/hedge/history/transfer/all',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    syncExchangeAccountReconciliationData(data){
        return http.post({
            url: '/admin/sync/exchange/account/reconciliation',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    getLocalTime(unixTimeStamp) {
        if (unixTimeStamp){
            unixTimeStamp = new Date(unixTimeStamp)
            let Y = unixTimeStamp.getFullYear() + '-';
            let M = (unixTimeStamp.getMonth()+1 < 10 ? '0'+(unixTimeStamp.getMonth()+1) : unixTimeStamp.getMonth()+1) + '-';
            let D = (unixTimeStamp.getDate() < 10 ? '0'+unixTimeStamp.getDate() : unixTimeStamp.getDate()) + ' ';
            let h = (unixTimeStamp.getHours() < 10 ? '0'+unixTimeStamp.getHours() : unixTimeStamp.getHours()) + ':';
            let m = (unixTimeStamp.getMinutes() < 10 ? '0'+unixTimeStamp.getMinutes() : unixTimeStamp.getMinutes()) + ':';
            let s = (unixTimeStamp.getSeconds() < 10 ? '0'+unixTimeStamp.getSeconds() : unixTimeStamp.getSeconds());
            return Y+M+D+h+m+s;
        }
    },

    export2Excel(columns, list, title) {
        require.ensure([], () => {
            const {export_json_to_excel} = require('../../../excel/Export2Excel');
            let tHeader = []
            let filterVal = []
            if (!columns) {
                return;
            }
            columns.forEach(item => {
                tHeader.push(item.title)
                filterVal.push(item.key)
            })
            const data = list.map(v => filterVal.map(j => v[j]))
            export_json_to_excel(tHeader, data, title);
        });
    },
}

